import { defineAsyncComponent } from 'vue'
import { useAccountStore } from '~/stores/account'

export const usePickemAuth = () => {
  const accountStore = useAccountStore()
  const { $dialog } = useNuxtApp()

  const ensureAuthorized = (): Promise<void> => {
    if (accountStore.isAuthorized) {
      return Promise.resolve()
    }

    return new Promise((resolve, reject) => {
      $dialog({
        content: defineAsyncComponent(
          () => import('~/components/account/sign-in.vue')
        ),
        wrapper: null,
        onClose: success => {
          if (success === true) {
            resolve()
          } else {
            reject(new Error('Unauthorized'))
          }
        }
      })
    })
  }

  return { ensureAuthorized }
}
